// Релегация: штрафное время, добавленное гонщику за нарушение правил участия.
// Штраф уже входит в finish_time этапа, который приходит с бэкенда, — здесь
// только форматирование для значка и подсказки.

// Штраф в виде +M:SS (или +H:MM:SS): в тех же долях, что и время в протоколе,
// но без сотых — релегацию выписывают целыми секундами
export const formatPenalty = (seconds) => {
  const total = Math.max(0, Math.round(Number(seconds) || 0));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const rest = total % 60;

  if (hours > 0) {
    return `+${hours}:${String(minutes).padStart(2, '0')}:${String(rest).padStart(2, '0')}`;
  }

  return `+${minutes}:${String(rest).padStart(2, '0')}`;
};

export const splitPenalty = (seconds) => {
  const total = Math.max(0, Math.round(Number(seconds) || 0));

  return { minutes: Math.floor(total / 60), seconds: total % 60 };
};

// Релегации гонщика по переданным этапам: сумма штрафа и расшифровка по этапам.
// routeDetails — тот же набор этапов, по которому считается зачет, поэтому при
// просмотре протокола на N-м этапе более поздние штрафы в сумму не попадают
export const getRelegationSummary = (userId, routeDetails) => {
  const entries = [];

  (routeDetails || []).forEach((routeDetail, index) => {
    const result = (routeDetail.results || []).find(item => item.user_id === userId);
    if (!result || result.status !== 'FINISHED' || !result.relegation) return;

    entries.push({
      stage: index + 1,
      routeName: routeDetail.route ? routeDetail.route.name : null,
      seconds: result.relegation.seconds,
      reason: result.relegation.reason
    });
  });

  if (entries.length === 0) return null;

  return {
    total: entries.reduce((sum, entry) => sum + entry.seconds, 0),
    entries
  };
};

// Подсказка значка: заголовок со штрафом и по строке на каждый этап с причиной
export const formatRelegationTitle = (entries, t) => {
  const total = entries.reduce((sum, entry) => sum + entry.seconds, 0);
  const header = t('results.relegation_title').replace('{penalty}', formatPenalty(total));

  const lines = entries.map(entry => {
    const key = entry.reason ? 'results.relegation_line_reason' : 'results.relegation_line';

    return t(key)
      .replace('{stage}', entry.stage)
      .replace('{route}', entry.routeName || '')
      .replace('{penalty}', formatPenalty(entry.seconds))
      .replace('{reason}', entry.reason || '');
  });

  return [header, ...lines].join('\n');
};
